<template>
  <div>
    <div>
      <Card>
        <Input
          v-model="keyword"
          search
          @on-search="searchProject()"
          placeholder="请输入工程关键字"
          style="width: auto;margin-left:20px;"
        />
      </Card>
      <Card style="margin-top:10px;">
        <!-- 新增客户开始 -->
        <div class="newuser">
          <Form :model="formProject" :label-width="80" inline>
            <Row>
              <i-col span="6">
                <FormItem label="工程名：" prop="prjName">
                  <i-input
                    type="text"
                    :disabled="this.query.projectId?true:false"
                    v-model="formProject.prjName"
                  ></i-input>
                </FormItem>
              </i-col>
              <i-col span="6">
                <FormItem label="工程编号：" prop="prjNum">
                  <i-input type="text" v-model="formProject.prjNum"></i-input>
                </FormItem>
              </i-col>
              <i-col span="6">
                <FormItem label="租户名称" prop="clientId" :rules=" [{ required: true}]">
                  <Select v-model="formProject.clientId" clearable style="width:200px">
                    <Option
                      v-for="item in cityList"
                      :value="item.value"
                      :key="item.value"
                    >{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </i-col>
            </Row>
          </Form>
          <Form
            :model="formProject"
            label-position="left"
            :label-width="100"
            style="margin-top:30px; width：80%"
          ></Form>
        </div>
        <!-- 新增用户结束 -->
        <div class="btnOKCancel">
          <button class="canclebtn" @click="cancel_clickHandler">取消</button>
          <button class="addsubmit" @click="handleSubmit" v-show="showFixed">确定</button>
        </div>
      </Card>
    </div>
  </div>
</template>
<script>
import $axios from "@/prjapiall/prjapi";
import api from "@/api/api";
import { global } from "../../globals/global";
// import api from "@/api/api";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      keyword: "",
      showFixed: false,
      formProject: {
        id: "",
        clientId: "",
        prjName: "",
        prjNum: "",
        cityList: [],
        password: "123456",
        projectId: "",
        checkpassword: "123456",
        roleList: [{ roleName: 1 }],
        roleId: 0
      },
      province: "",
      city: "",
      county: "",
      roleList: [],
      provinceList: [],
      cityList: [],
      countyList: [],
      path: []
    };
  },
  computed: {
    ...mapGetters({
      getUser: "getUser"
    }),
    query() {
      return this.$route.query;
    }
  },
  components: {},
  methods: {
    getTenant() {
      api.queryClientList({}).then(res => {
        let data = res.data;
        if (data.code === 0) {
          for (let i = 0; i < data.page.list.length; i++) {
            this.cityList.push({
              label: data.page.list[i].cliName,
              value: data.page.list[i].id.toString()
              // parentName: item.parentName
            });
          }
          this.formProject.clientId = this.cityList[0].value;
        } else {
          this.$Message.error(data.msg);
        }
      });
    },
    handleSubmit() {
      let { prjName, prjNum, clientId } = this.formProject;
      // if (!cliphone) return this.$Message.error("手机号不能为空");
      let params = Object.assign(
        {},
        {
          prjName,
          prjNum,
          clientId
        }
      );
      let projectId = this.query.projectId;
      if (projectId) {
        let id = projectId;
        api.updateProjectById({ ...params, id }).then(res => {
          let data = res.data;
          if (data.code === 0) {
            this.$Message.success("更新成功");
            this.$router.back();
          } else {
            this.$Message.error(data.msg);
          }
        });
      } else {
        if (this.formProject.prjName == "" || this.formProject.prjNum == "") {
          this.$Message.info("请输入完整信息");
          return;
        }
        $axios("POST", "newProject", { ...params }).then(res => {
          let data = res.data;
          if (data.code === 0) {
            this.$Message.success("添加成功");
            this.path = [];
            // this.getResty(data.new_id);
          } else {
            this.$Message.error(data.msg);
          }
        });
      }
      setTimeout(() => {
        this.$router.back();
      }, 1000);
    },
    // getResty(prjid) {
    //   $axios("GET", "queryProjectById", {}, prjid).then(({ data }) => {
    //    
    //     this.path.push(data["project"].clientId, data["project"].id);
    //     global.$emit("position", this.path);
    //   });
    // },
    cancel_clickHandler() {
      this.$router.back();
    },
    // 关闭页面
    closePage() {
      this.$router.push({ name: "home" });
    },
    getCityData(parentId = "0", type) {
      api.sysQueryDistrictList({ parentId, limit: 1000 }).then(res => {
        let data = res.data;
        if (data) {
          if (type === "county") {
            this.countyList = data["page"]["list"];
          } else if (type === "city") {
            this.cityList = data["page"]["list"];
          } else {
            this.provinceList = data["page"]["list"];
          }
        } else {
          this.$Message.error(data.msg);
        }
      });
    },
    searchProject() {
      this.$router.push({
        name: "engineering_index",
        query: {
          keyword: this.keyword
        }
      });
    }
  },
  created() {
    // let tnp = this.query.projectId ? 0 : 1;
    // this.showFixed =
    //   api.getRoleAuth(this.$store.state.user, 4023) ||
    //   (api.getRoleAuth(this.$store.state.user, 4021) && tnp);
    this.showFixed = true; //api.getRoleAuth(this.$store.state.user, 4021);
    this.showDelInfo = true; //api.getRoleAuth(this.$store.state.user, 4022);
  },
  mounted() {
    if (this.query.projectId) {
      api.queryProjectById({ id: this.query.projectId }).then(res => {
        let data = res.data;
        if (data) {
          this.formProject = Object.assign({}, data["project"]);
        } else {
          this.$Message.error(data.msg);
        }
      });
    }
    this.getTenant();
  },
  watch: {
    province(val) {
      this.city = "";
      this.county = "";
      this.countyList = [];
      this.getCityData(String(val), "city");
    },
    city(val) {
      if (!val) return;
      this.getCityData(String(val), "county");
    }
  }
};
</script>
<style>
.usereditbox {
  padding: 20px;
}

.usereditbox .title {
  padding: 20px 0;
  position: relative;
}

.usereditbox .title .bluecolor {
  color: #3385ff;
}

.usereditbox .title .sysicon {
  position: relative;
  padding-left: 8px;
}

.usereditbox .title .sysicon:before {
  content: "";
  width: 4px;
  height: 100%;
  background: #3385ff;
  position: absolute;
  left: 0;
  top: 0;
}

.btnOKCancel {
  margin: 20px 0;
  text-align: center;
}

.canclebtn,
.addsubmit {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  margin: 0 20px;
}

.canclebtn {
  background: #eaeaea;
}
.addsubmit {
  background: #3385ff;
  color: #fff;
}
</style>
